import React from "react";

const SocialComponent = () => {
    return(
        <>
            <div className="templatemo-top-bar">
        <div className="container">
          <div className="subheader">
            <div className="socicons pull-left">
              <ul>
                <li> <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook fa-lg"></i></a></li>
                <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter fa-lg"></i></a></li>
                <li><a href="https://in.linkedin.com/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin fa-lg"></i></a></li>
                <li><a href="https://plus.google.com/" target="_blank" rel="noopener noreferrer"><i className="fa fa-google-plus fa-lg"></i></a></li>
              </ul>
            </div>
            <div className="pull-right">
              <ul className="email">
                <li><i className="fa fa-phone fa-lg"></i> Call Us: 919-656-7976 or 919-491-2179</li>
                <li className="bor-none"><i className="fa fa-envelope fa-lg"></i>
                  <a href="mailto:hr@avveniresolutions.com">hr@avveniresolutions.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}


export default SocialComponent;